/**
 * 수익성분석 상수
 */

export const ProfitConst = {
  //----------------------------------
  // 공통
  //----------------------------------
  //----------------------------------
  // 화면 변수
  //----------------------------------
  // 레이블
  label: {
    APPLY: "적용",
    CANCEL: "취소",
  },
  //----------------------------------
  // 데이터 변수
  //----------------------------------
  // 모델 용도
  modelType: {
    HCOST: "간편견적",
    FBN: "농창업처방전",
  },
  // 인입 경로
  inflowType: {
    HANDWORK: "직접입력",
    PROFIT: "수익성분석",
    WIRELINE: "유선상담",
  },
  // 공개여부
  published: {
    PUBLISHED: "공개",
    UNPUBLISHED: "비공개",
  },
  // 지출명
  expenseName: {
    FM_CONSULTING: "팜모닝 컨설팅",
  },
} as const;
